var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWalk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 34,
    viewBox: "0 0 52 34",
    width: 52,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h52v34h-52z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#3a3a3a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.48 -1321.834)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-36.031 1332.455a2.31 2.31 0 0 1 -2.305-2.316 2.311 2.311 0 0 1 2.316-2.305 2.311 2.311 0 0 1 2.305 2.316 2.308 2.308 0 0 1 -2.312 2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-42.48 1339.988a4.76 4.76 0 0 1 4.76-4.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-40.1 1342.367c2.508 0 4.538 3.2 4.538 7.156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-32.961 1339.988a4.76 4.76 0 0 1 -4.759-4.76"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m25.761 13.395-4.76 14.278"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalk);
export default __webpack_public_path__ + "static/media/walk.55d2f108a2be4bcd9f7080f18ce5090a.svg";
export { ForwardRef as ReactComponent };